import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import './MyContracts.css';
import Sidebar from './sidebar';

const MyContracts = () => {
  const [contracts, setContracts] = useState([]);
  const [groupedContracts, setGroupedContracts] = useState({});
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const fetchContracts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}v1/contracts_view`, {
          headers: {
            'x-api-key': '12345xxa',
          },
        });
        setContracts(response.data);
      } catch (error) {
        console.error('Ошибка при получении данных о договорах:', error);
      }
    };

    fetchContracts();
  }, [id]);

  useEffect(() => {
    if (contracts.length > 0) {
      const grouped = contracts.reduce((acc, contract) => {
        const key = contract.id_contract;
        if (!acc[key]) {
          acc[key] = {
            ...contract,
            products: [],
          };
        }
        acc[key].products.push({
          id_contractitem: contract.id_contractitem,
          product_name: contract.product_name,
          measure_name: contract.measure_name,
          product_price: contract.product_price,
          product_amount: contract.product_amount,
          product_balance: contract.product_balance,
        });
        return acc;
      }, {});
      setGroupedContracts(grouped);
    }
  }, [contracts]);

  const handleApplyClick = (contractId) => {
    navigate(`/Apply?contract=${contractId}`);
  };

  return (
    <div className="main-container-client-details">
      <Sidebar className="sidebar-client-details" />
      <div className="content-client-details">
        <h2>Мои договора</h2>
        {Object.keys(groupedContracts).length > 0 ? (
          Object.values(groupedContracts)
            .filter(contract => contract.id_contract === id)
            .map(contract => (
              <div key={contract.id_contract} className="client-details">
                <div className="clientdetails-header">
                  <h1>Договор: {contract.contract_number}</h1>
                  <div className="id">
                    <span>ID:</span> <span>{contract.id_contract}</span>
                  </div>
                </div>
                <div className="additional-info">
                  <div>Организация: {contract.organization_name}</div>
                  <div>Клиент: {contract.client_name}</div>
                  <div>Дата Договора: {new Date(contract.contract_date).toLocaleDateString()}</div>
                </div>
                <div className="contract-actions">
                  <button onClick={() => handleApplyClick(contract.id_contract)} className="apply-button">
                    Подать заявку
                  </button>
                </div>
                <div className="contracts">
                  <h3>Товары по договору</h3>
                  <table className="contract-products-table">
                    <thead>
                      <tr>
                        <th>ID Товара</th>
                        <th>Название</th>
                        <th>Единица измерения</th>
                        <th>Цена</th>
                        <th>Количество</th>
                        <th>Сумма</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contract.products.map(product => (
                        <tr key={product.id_contractitem}>
                          <td>{product.id_contractitem}</td>
                          <td>{product.product_name}</td>
                          <td>{product.measure_name}</td>
                          <td>{product.product_price}</td>
                          <td>{product.product_amount}</td>
                          <td>{product.product_balance}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))
        ) : (
          <p>Нет доступных договоров.</p>
        )}
      </div>
    </div>
  );
};

export default MyContracts;
